import { HmacSHA256 } from "crypto-js";
import { checksumSecretKey } from "../../Constants/config";
import { IChartDetailsDateAndValue } from "../Components/ChartDetailsComp";

export const _capitalizeForLocalization = (str: string) => {
  return str.split(" ").map(s => s.toLocaleUpperCase()).join("_");
}


export const _generateCheckSum = (dataObj: any) => {
  const shaValue = HmacSHA256(JSON.stringify(dataObj), checksumSecretKey);
  return shaValue.toString();
};

export const getDateFromUTC = (isoDate: string) => {
  // Create a new Date object from the ISO format string
  //this function converts date into Indian standard time
  var dateObject = new Date(new Date(isoDate).getTime() + 5.5 * 60 * 60 * 1000);

  // Extract the date components
  var year = dateObject.getUTCFullYear();
  var month = dateObject.getUTCMonth() + 1; // Note: month is zero-based, so adding 1
  var day = dateObject.getUTCDate();

  // Construct the date string
  return `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
};

export const getTimeFromUTC = (isoDate: string) => {
  // Create a new Date object
  var dateObject = new Date(isoDate);

  // Extract the time components
  var hours = dateObject.getHours();
  var minutes = dateObject.getMinutes();
  var seconds = dateObject.getSeconds();

  // Construct the time string
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

export const getCurrentDateandTimeInIST = (date: Date) => {
  // Create a new Date object
  const currentDate = new Date(date);

  // Set the time zone to IST (Indian Standard Time)
  currentDate.setUTCHours(currentDate.getUTCHours() + 5, 30); // Adjust for IST offset of +5:30 hours

  // Format the date and time in ISO format
  const isoDate = currentDate.toISOString();

  // Append the timezone offset
  return isoDate.slice(0, -1) + "+00:00";
};

export const getLastUpdated = (last_updated_on: string) => {
  // Get the current time in milliseconds
  var currentTime = new Date().getTime();

  // Get the input time in milliseconds (replace 'inputTime' with the actual input time)
  var inputTime = new Date(last_updated_on).getTime();

  // Calculate the time difference in milliseconds
  var timeDifference = currentTime - inputTime;
  var min = Math.floor(timeDifference / (1000 * 60));
  // Calculate the time difference in days

  var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  // Determine the appropriate label based on the number of days
  var label;
  if (days === 0) {
    if (min <= 1) {
      label = "Updated just now";
    } else {
      label = "Updated Today";
    }
  } else if (days === 1) {
    label = "Updated Yesterday";
  } else if (days <= 6) {
    label = `Updated ${days} days ago`;
  } else {
    label = "Updated weeks ago";
  }

  return label;
};

export const _generateCustomCheckSum = (
  dataObj: any,
  checksumSecretKey: string
) => {
  const shaValue = HmacSHA256(JSON.stringify(dataObj), checksumSecretKey);
  return shaValue.toString();
};

export const xAxisDay = () => {
  return [
    ["12", "AM"],
    ["", ""],
    ["", ""],
    ["3", "AM"],
    ["", ""],
    ["", ""],
    ["6", "AM"],
    ["", ""],
    ["", ""],
    ["9", "AM"],
    ["", ""],
    ["", ""],
    ["12", "PM"],
    ["", ""],
    ["", ""],
    ["3", "PM"],
    ["", ""],
    ["", ""],
    ["6", "PM"],
    ["", ""],
    ["", ""],
    ["9", "PM"],
    ["", ""],
    ["", ""],
  ];
};
export const xAxisDay1 = () => {
  return [
    "12AM",
    "",
    "",
    "3AM",
    "",
    "",
    "6AM",
    "",
    "",
    "9AM",
    "",
    "",
    "12PM",
    "",
    "",
    "3PM",
    "",
    "",
    "6PM",
    "",
    "",
    "9PM",
  ];
};

export const xAxisWeek = () => {
  return [
    ["1", "Sun"],
    ["2", "Mon"],
    ["3", "Tue"],
    ["4", "Wed"],
    ["5", "Thu"],
    ["6", "Fri"],
    ["7", "Sat"],
  ];
};
export const xAxisWeek1 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const adjustMinMax = (array: number[]) => {
  const minValue = Math.min(...array);
  const maxValue = Math.max(...array);

  let adjustedMin = minValue - 5;
  let adjustedMax = maxValue + 5;

  if (adjustedMax - adjustedMin < 10) {
    adjustedMin = Math.max(0, adjustedMin - 2);
    adjustedMax = adjustedMax + 2;
  }

  return [adjustedMin, adjustedMax];
};

export function iterateDates(
  startDate: string,
  endDate: string,
  dateTimeArray: IChartDetailsDateAndValue[]
): [number[], string[], string[]] {
  const start: Date = new Date(startDate);
  const end: Date = new Date(endDate);
  let dateArray: string[] = [];
  let timeArray: string[] = [];

  const result: number[] = [];
  // console.log("start end: ", start, end)

  // Iterate over each date
  for (
    let date: Date = new Date(start);
    date <= end;
    date.setUTCDate(date.getUTCDate() + 1)
  ) {
    const day: string = date.getDate().toString().padStart(2, "0"); // Get day and pad with leading zero if needed
    const month: string = (date.getMonth() + 1).toString().padStart(2, "0"); // Get month (zero-based) and pad with leading zero if needed
    const year: string = date.getFullYear().toString(); // Get full year

    const dateString: string = `${year}-${month}-${day}`;

    // Find matching date in dateTimeArray
    const matchedDateTime: IChartDetailsDateAndValue | undefined =
      dateTimeArray.find((dateTime) => dateTime.date === dateString);
    // console.log("date matched: ", date, dateString)

    if (matchedDateTime) {
      // Date matched with date-time
      result.push(matchedDateTime.value);
      dateArray.push(getDateinText(new Date(matchedDateTime.date)));
      timeArray.push(matchedDateTime.time);
    } else {
      // No matching date found, use 0
      result.push(0);
      dateArray.push("");
      timeArray.push("");
    }
  }

  return [result, dateArray, timeArray];
}

export function prepareHourlyValues(
  dateTimeArray: IChartDetailsDateAndValue[]
): [number[], string[], string[]] {
  const hourArray: number[] = Array(24).fill(0);
  const timeArray: string[] = Array(24).fill("");
  const dateArray: string[] = Array(24).fill("");

  // Iterate over the dateTimeArray
  dateTimeArray.forEach(({ date, time, value }, index) => {
    // Convert date and time to a Date object
    const dateTime = new Date(`${date}T${time}`);
    const hour = dateTime.getHours();

    // Check if the hour is within the range of 0-23
    if (hour >= 0 && hour <= 23) {
      // Update the hourArray with the value
      hourArray[hour] = value;
      timeArray[hour] = time;
      dateArray[hour] = getDateinText(new Date(date));
    }
  });

  return [hourArray, dateArray, timeArray];
}

export function computeDateTimeHour(dateString: string, timeString: string) {
  // console.log("datestring", dateString, "timestring", timeString);
  const istDateTime = new Date(`${dateString}T${timeString}+05:30`);
  const startDateTime = new Date(istDateTime.getTime());
  const endDateTime = new Date(istDateTime.getTime() + 60 * 60 * 1000);

  const startGMT = startDateTime.toISOString();
  const endGMT = endDateTime.toISOString();

  // Print the output
  return [startGMT, endGMT];
}

export function computeDateTimeDay(dateString: string, timeString: string) {
  const istDateTime = new Date(`${dateString}T00:00:00+05:30`);
  const startDateTime = new Date(istDateTime.getTime());
  const endDateTime = new Date(istDateTime.getTime() + 24 * 60 * 60 * 1000);

  const startGMT = startDateTime
    .toISOString()
    .replace(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2}).*/, "$1T18:30:00Z");
  const endGMT = endDateTime
    .toISOString()
    .replace(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2}).*/, "$1T18:30:00.000Z");

  // Print the output
  return [startGMT, endGMT];
}

export function convertGMTtoIST(gmtTimestamp: string): string {
  const gmtDate = new Date(gmtTimestamp);
  const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds (+5 hours 30 minutes)
  const istDate = new Date(gmtDate.getTime() + istOffset);

  const hours = istDate.getUTCHours().toString().padStart(2, "0");
  const minutes = istDate.getUTCMinutes().toString().padStart(2, "0");
  const seconds = istDate.getUTCSeconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}
export enum Elocation {
  "FitnessTracker" = "/healthpatri/fitness",
}
export const getDateinText = (dateState: Date) => {
  const date = new Date(dateState);

  const day = date.toLocaleString("en", { day: "2-digit" });
  const month = date.toLocaleString("en", { month: "short" });
  const year = date.toLocaleString("en", { year: "numeric" });

  return `${day} ${month} ${year}`;
};
export function convertStringToDate(dateString: string) {
  const parts = dateString.split(" ");
  const datePart = parts[0];
  const timePart = parts[1];
  const timeZonePart: any = parts[2];

  const [day, month, year] = datePart.split("-");
  const [hours, minutes, seconds] = timePart.split(":");
  const timeZoneOffset =
    timeZonePart.substring(0, 3) * 60 + timeZonePart.substring(3) * 1;

  const utcDate = new Date(
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hours),
      Number(minutes),
      Number(seconds)
    )
  );
  const convertedDate = new Date(utcDate.getTime() - timeZoneOffset * 60000);

  return convertedDate;
}
